import { ChartOptions } from "chart.js";
import GraphContent from "../../../components/graphContent/graph_content";
import { translate } from "@/main";

export function createChartOptions(
  range: GraphContent["range"],
): ChartOptions {
  const options: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0,
    },
    tooltips: {
      enabled: true,
    },
    layout: {
      padding: {
        top: 0,
        right: 30,
        bottom: 0,
        left: 0,
      },
    },
    legend: {
      display: false,
      onClick(event, legendItem) {
        return;
      },
      fullWidth: false,
      labels: {
        boxWidth: 15,
      },
      position: "bottom"
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            autoSkip: true,
          },
          scaleLabel: {
            display: true,
            labelString: `${translate("message.dateAndTime")}`
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
          },
          scaleLabel: {
            display: false,
          },
          ticks: {
            autoSkip: true,
          },
        },
      ],
    },
  };
  if (range.enabled) {
    options.scales.yAxes[0].ticks.min = Number(range.min);
    options.scales.yAxes[0].ticks.max = Number(range.max);
  }

  return options;
}
